import { render, staticRenderFns } from "./MultipleAirportsTag.vue?vue&type=template&id=8a77d624&scoped=true&"
import script from "./MultipleAirportsTag.vue?vue&type=script&lang=js&"
export * from "./MultipleAirportsTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a77d624",
  null
  
)

export default component.exports